import { Utils } from "@/app/infrastructures/misc";
import { ReschedulePickupResponse } from "@/data/responses/contracts/ReschedulePickupResponseInterface";
import { BaseResponse } from "@/domain/entities/BaseResponse";
import { Pagination } from "@/domain/entities/Pagination";
import {
  ReschedulePickup,
  ReschedulePickupCourier,
  ReschedulePickupDetail,
  ReschedulePickupDetailV2,
  ReschedulePickupDetailVShipment,
  ReschedulePickups,
  SubDistrict,
  Village
} from "@/domain/entities/ReschedulePickup";
import { AxiosResponse } from "axios";

export class ReschedulePickupMapper extends BaseResponse {
  public convertSubDistrictFromApi(result: AxiosResponse): SubDistrict {
    const { data:
      { sub_districts }
    } = result
    return sub_districts.map((item: string ) => {
      return new SubDistrict(item)
    })
  }

  public convertVillageFromApi(result: AxiosResponse): Village {
    const { data:
    { villages }
  } = result
    return villages.map((item: string) => {
      return new Village(item)
    })
  }

  public convertReschedulePickupsFromApi(result: AxiosResponse): ReschedulePickups {
    const { data:
      { data, pagination }
    } = result

    return new ReschedulePickups(
      data.map((item: ReschedulePickupResponse) => {
        return new ReschedulePickup (
          item?.shipment_id,
          item?.group_id,
          item?.customer_name,
          item?.customer_phone_number,
          item?.statuses,
          item?.reschedule_type,
          new ReschedulePickupCourier(
            item?.courier?.courier_id,
            item?.courier?.fullname,
            item?.courier?.courier_type,
            item?.courier?.phone_number
          ),
          item?.rescheduled_at,
          item?.customer_address,
          item?.created_at,
          item?.duration,
          item?.status_approval,
          item.is_priority || false,
          item.pickup_booster_amount || 0,
          item?.longitude || 0,
          item?.latitude || 0,
          item?.client_id || "",
          item?.client_name || "",
          item?.total_shipment || 0,
          item?.total_quantity || 0,
          item?.shipment_type || ""
        )
      }),
      Utils.toInstance(new Pagination(), pagination),
    )
  }

  public convertReschedulePickupDetailFromApi(result: AxiosResponse): ReschedulePickupDetail {
    const { data } = result

    return new ReschedulePickupDetail(
      data?.shipment_id,
      data?.group_id,
      data?.customer_name,
      data?.customer_phone_number,
      data?.customer_address,
      data?.latitude,
      data?.longitude,
      data?.rescheduled_at,
      data?.created_at,
      data?.status_approval,
      data?.last_reason,
      data?.meta,
      data.assigned_courier ?
      new ReschedulePickupCourier(
        data?.assigned_courier?.courier_id,
        data?.assigned_courier?.fullname,
        data?.assigned_courier?.courier_type,
        data?.assigned_courier?.phone_number
      ) : null,
      new ReschedulePickupCourier(
        data?.last_courier?.courier_id,
        data?.last_courier?.fullname,
        data?.last_courier?.courier_type,
        data?.last_courier?.phone_number,
        data?.last_courier?.latitude,
        data?.last_courier?.longitude,
        data?.last_courier?.distance
      ),
      data.is_priority || false,
      data.pickup_booster_amount || 0
    )
  }

  public convertReschedulePickupDetailV2FromApi(result: AxiosResponse): ReschedulePickupDetailV2 {
    const { data: dataRes } = result || {};
    const { data, pagination } = dataRes || {}

    return new ReschedulePickupDetailV2({
      shipperHash: data?.shipper_hash,
      senderName: data?.sender_name,
      senderPhone: data?.sender_phone,
      senderAddress: data?.sender_address,
      courierName: data?.courier_name,
      courierPhone: data?.courier_phone,
      courierReason: data?.courier_reason,
      courierRequestedAt: data?.courier_requested_at,
      statusApproval: data?.status_approval,
      approvedBy: data?.approved_by,
      approvedAt: data?.approved_at,
      rejectionReason: data?.rejection_reason,
      rejectedBy: data?.rejected_by,
      rejectedAt: data?.rejected_at,
      nextCourierId: data?.next_courier_id,
      nextCourierName: data?.next_courier_name,
      nextPickupDate: data?.next_pickup_date,
      nextPickupTime: data?.next_pickup_time,
      nextCourierAgentCode: data?.next_courier_agent_code,
      nextCourierAgentName: data?.next_courier_agent_name,
      nextCourierType: data?.next_courier_type,
      rescheduledType: data?.rescheduled_type,
      latitude: data?.latitude,
      longitude: data?.longitude,
      courierAgentCode: data?.courier_agent_code,
      courierAgentName: data?.courier_agent_name,
      courierId: data?.courier_id,
      courierType: data?.courier_type,
      shipmentId: data?.shipment_id,
      pagination: Utils.toInstance(new Pagination(), pagination),
      shipments: (data?.shipments || []).map((item: any) => new ReschedulePickupDetailVShipment({
        shipmentId: item.shipment_id,
        productType: item.product_type,
        totalColly: item.total_colly
      })),
      proofUrls: data?.proof_urls ?? [],
    })
  }

  public convertReschedulePickupTotalCounterFromApi(result: AxiosResponse): number {
    const { data } = result

    return data.total
  }
}
